<style scoped>
.form-control {
  font-size: 1em;
}
</style>
<template>
  <section>
    <br />
    <div class="card">
      <div class="card-header active list-group-item">Daily Journal</div>
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <a
              class="font-weight-bold"
              href="#"
              v-on:click.prevent="showDatePicker=!showDatePicker"
            >{{data.daily.date | moment('ddd MMM DD, YYYY')}}</a>
            <b-modal v-model="showDatePicker" :hide-footer="true" title="Select Date">
              <div class="d-flex justify-content-center">
                <div class="center">
                  <datepicker
                    v-model="data.daily.date"
                    format="D MMM dd, yyyy"
                    inline
                    v-on:selected="showDatePicker=false"
                  ></datepicker>
                </div>
              </div>
            </b-modal>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-sm-12 col-md-6 text-center">
                <div class="form-group form-inline">
                  <label for="locationID">Location:</label>
                  <select class="form-control" v-model="data.locationId">
                    <option v-for="l in userLocations" :key="l.id" v-bind:value="l.id">{{l.name}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Week To Date -->
        <div class="journal row">
          <div class="col-xs-12 table-responsive">
            <table class="table table-condensed table-striped standard-report">
              <thead>
                <tr class="table-header text-center small">
                  <th></th>
                  <th class="text-right">Week To Date</th>
                  <th class="text-right">Last year</th>
                  <th class="text-center">%</th>
                  <th class="text-right">Period To Date</th>
                  <th class="text-right">Last year</th>
                  <th class="text-center">%</th>
                  <th class="text-right">Year To Date</th>
                  <th class="text-right">Last year</th>
                  <th class="text-center">%</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-right" v-if="grossView">
                  <td class="header">Gross</td>
                  <td class="text-right">{{data.todatemetrics.wtdgross|currency}}</td>
                  <td class="text-right">{{data.todatemetrics.prevwtdgross|currency}}</td>
                  <td class="text-center">{{data.todatemetrics.wpctgross}}</td>
                  <td class="text-right">{{data.todatemetrics.ptdgross|currency}}</td>
                  <td class="text-right">{{data.todatemetrics.prevptdgross|currency}}</td>
                  <td class="text-center">{{data.todatemetrics.ppctgross}}</td>
                  <td class="text-right">{{data.todatemetrics.ytdgross|currency}}</td>
                  <td class="text-right">{{data.todatemetrics.prevytdgross|currency}}</td>
                  <td class="text-center">{{data.todatemetrics.ypctgross}}</td>
                </tr>
                <tr class="border-right" v-if="!grossView">
                  <td class="header">Net</td>
                  <td class="text-right">{{data.todatemetrics.wtd|currency}}</td>
                  <td class="text-right">{{data.todatemetrics.prevwtd|currency}}</td>
                  <td class="text-center">{{data.todatemetrics.wpct}}</td>
                  <td class="text-right">{{data.todatemetrics.ptd|currency}}</td>
                  <td class="text-right">{{data.todatemetrics.prevptd|currency}}</td>
                  <td class="text-center">{{data.todatemetrics.ppct}}</td>
                  <td class="text-right">{{data.todatemetrics.ytd|currency}}</td>
                  <td class="text-right">{{data.todatemetrics.prevytd|currency}}</td>
                  <td class="text-center">{{data.todatemetrics.ypct}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Reports -->
        <div class="row">
          <div class="col">
            <b-tabs v-model="activeTab">
              <b-tab
                v-for="(t, tabindex) in data.tabs"
                :key="tabindex"
                title-item-class="small"
                :title="t.name"
                class="card"
              >
                <div class="table-responsive-md" style="padding-top: 10px;">
                  <div class>
                    <!-- <keep-alive> -->
                    <component
                      :is="t.component"
                      v-bind:location-id="data.locationId"
                      v-bind:daily-date="data.daily.date"
                      v-bind:is-active="t.isActive"
                    ></component>
                    <!-- </keep-alive> -->
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import dailyJournalSales from '@/views/dailyJournal/dailyJournalSales'
import dailyJournalDiscounts from '@/views/dailyJournal/dailyJournalDiscounts'
import dailyJournalCategories from '@/views/dailyJournal/dailyJournalCategories'
import dailyJournalVoids from '@/views/dailyJournal/dailyJournalVoids'
import dailyJournalItems from '@/views/dailyJournal/dailyJournalItems'
import UserService from '@/services/UserService'
import DailyJournalReportService from '@/services/DailyJournalReportService'
import Datepicker from 'vuejs-datepicker'
import dailyJournalProfitCentersVue from './dailyJournalProfitCenters.vue'
import dailyJournalEmployeeSummaryVue from './dailyJournalEmployeeSummary.vue'
import dailyJournalLaborVue from './dailyJournalLabor.vue'

export default {
  components: {
    dailyJournalSales,
    dailyJournalDiscounts,
    Datepicker,
    dailyJournalCategories,
    dailyJournalVoids,
    dailyJournalItems
  },
  data () {
    return {
      showDatePicker: false,
      data: {
        loading: false,
        user_id: 0,
        locationId: 0,
        wtdsales: 1,
        ptdsales: 1,
        activetab: 0,
        todatemetrics: {},
        tabs: [
          { name: 'Sales', data: 'salesSummary', component: dailyJournalSales, isActive: 1 },
          { name: 'Categories', data: 'categorySummary', component: dailyJournalCategories, isActive: 0 },
          { name: 'Discounts/Comps', data: 'discountSummary', component: dailyJournalDiscounts, isActive: 0 },
          { name: 'Voids', data: 'voidSummary', component: dailyJournalVoids },
          { name: 'Labor', data: 'laborSummary', component: dailyJournalLaborVue },
          { name: 'Items', data: 'trackedItemSummary', component: dailyJournalItems },
          { name: 'Profit Centers', data: 'profitCenterSummary', component: dailyJournalProfitCentersVue },
          { name: 'Employee Summary', data: 'employeePromoSummary', component: dailyJournalEmployeeSummaryVue }
        ],
        daily: {
          type: null,
          total: 0,
          date: null,
          next: null,
          prev: null,
          open: false,
          options: {}
        },
        report: {}
      },
      activeTab: 0
    }
  },
  props: {
    defaultLocationId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    'data.locationId': function (nv, ov) {
      if (nv !== ov) {
        this.reload()
      }
    },
    activeTab: function (n, o) {
      for (var i = 0; i < this.data.tabs.length; i++) {
        if (i === n) {
          this.data.tabs[i].isActive = 1
        } else {
          this.data.tabs[i].isActive = 0
        }
      }
    }
  },
  computed: {
    userLocations: function () {
      return UserService.getLocationsWithPermission('view daily')
    },
    reimportPermission: function () {
      if (this.data.locationId > 0) {
        return UserService.hasLocationPermission(this.data.locationId, 'pos reimport')
      }
      return false
    },
    grossView: function () {
      return UserService.getConfigOption('gross_sales_view').value === 'yes'
    }
  },
  methods: {
    reload: function () {
      this.getToDateMetrics()
    },
    getToDateMetrics: function () {
      this.$updateloading(1)
      DailyJournalReportService.getToDateMetrics(this.data.locationId, this.data.daily.date)
        .then(res => {
          this.$updateloading(-1)
          this.data.todatemetrics = res
        })
    },
    openDate: function () {
      if (this.data.loading) {
        return false
      }
      this.data.daily.open = !this.data.daily.open
    },
    changeDate: function (day) {
      if (this.data.loading) {
        return false
      }
      this.data.daily.date.setDate(this.data.daily.date.getDate() + parseInt(day))
      this.setDates()
      this.reload()
    },
    setDates: function () {
      this.data.daily.next = new Date(this.data.daily.date)
      this.data.daily.next.setDate(this.data.daily.date.getDate() + 1)
      this.data.daily.prev = new Date(this.data.daily.date)
      this.data.daily.prev.setDate(this.data.daily.date.getDate() - 1)
    },
    breakHeaderName: function (name) {
      var n = name.replace(/-/g, ' ')
      return n.replace(/\s+/g, '\n')
    },
    editLabor: function () {
    }
  },
  mounted: function () {
    /**
     * Setup date.
     */
    const params = new URLSearchParams(document.location.search.substring(1))
    if (params.get('date')) {
      this.data.daily.date = this.$moment(params.get('date')).toDate()
    } else {
      this.data.daily.date = this.$moment().subtract('1', 'Days').toDate()
    }
    this.setDates()

    if (this.defaultLocationId > 0) {
      // TODO check permission of location here
      this.data.locationId = this.defaultLocationId
    } else {
      this.data.locationId = this.userLocations[0].id
    }

    // this.data.locationId = locationId
    // this.loadTab(this.data.activetab)
  }
}
</script>
